import englishMessages from "ra-language-english";
import ruMessages from "./ru";
import { azRa } from "./az-ra";
import { appMessages } from "./app";
import { buildResources, type AdminLang } from "./labels";

const withApp = (lang: AdminLang, ra: Record<string, unknown>) => ({
  ...ra,
  resources: buildResources(lang),
  app: appMessages[lang],
});

export const adminMessages: Record<AdminLang, Record<string, unknown>> = {
  ru: withApp("ru", ruMessages as Record<string, unknown>),
  en: withApp("en", englishMessages as Record<string, unknown>),
  az: withApp("az", { ra: azRa }),
};
